import { create } from "zustand";

export type AskNexusPanelView = "chat" | "history";

interface AskNexusPanelState {
  isOpen: boolean;
  isWide: boolean;
  view: AskNexusPanelView;
  /** The open conversation, valid only for `tenantId`. */
  conversationId: string | null;
  /** The tenant the panel content belongs to; another tenant starts a fresh chat. */
  tenantId: string | null;
  /** Goes up on every close, so work that started before a close can tell, even after the panel reopened. */
  closeCount: number;
  open: () => void;
  close: () => void;
  toggleOpen: () => void;
  toggleWide: () => void;
  showHistory: () => void;
  showChat: () => void;
  newChat: () => void;
  openConversation: (conversationId: string) => void;
  syncTenant: (tenantId: string | null) => void;
}

export const useAskNexusPanel = create<AskNexusPanelState>((set) => ({
  isOpen: false,
  isWide: false,
  view: "chat",
  conversationId: null,
  tenantId: null,
  closeCount: 0,
  open: () => set({ isOpen: true }),
  close: () => set((state) => (state.isOpen ? { isOpen: false, isWide: false, closeCount: state.closeCount + 1 } : state)),
  toggleOpen: () =>
    set((state) => (state.isOpen ? { isOpen: false, isWide: false, closeCount: state.closeCount + 1 } : { isOpen: true })),
  toggleWide: () => set((state) => ({ isWide: !state.isWide })),
  showHistory: () => set({ view: "history" }),
  showChat: () => set({ view: "chat" }),
  newChat: () => set({ view: "chat", conversationId: null }),
  openConversation: (conversationId) => set({ view: "chat", conversationId }),
  syncTenant: (tenantId) =>
    set((state) => (state.tenantId === tenantId ? state : { tenantId, view: "chat", conversationId: null })),
}));
